export const HANDBOOK_SET_ORDER_ID = "HANDBOOK_SET_ORDER_ID";
export const HANDBOOKS_SAVE_TRANSACTION_DETAILS =
  "HANDBOOKS_SAVE_TRANSACTION_DETAILS";

export const HANDBOOKS_TAB = "HANDBOOKS_TAB";
